import { msgTypes } from 'constants/msgTypes';
import { useEffect, useState } from 'react'
import ErrorIcon from '@mui/icons-material/Error';
import ApiUrl from 'services/shared/ApiUrl';
import DispalyImage from 'components/wrapperComponents/DispalyImage';

const ImagePreview = ({ file, errorMessage }) => {
  return (
    <div>
        {errorMessage===undefined ?
            (
            // <img src={ApiUrl.fileBaseUrl+file} alt='preview'
            //   style={{height: "33px", width: "50px", objectFit: "contain"}}
            //   />
            <DispalyImage 
             imageUrl={file}
             imageSize={msgTypes.IMAGE_SIZE.XSMALL}
            />
            )
            : (<ErrorIcon color="error"  sx={{marginLeft:"42px"}}/>) }
    </div>
  )
}

export default ImagePreview
